export default __webpack_public_path__ + "static/media/hulu-logo.cc9e43a0.svg";